<template>
  <v-dialog v-model="dialog" max-width="400px">
    <template v-slot:activator="{ on, attrs }">
      <v-btn class="mr-2" color="#43405c" text v-bind="attrs" v-on="on"
        >Créer un compte</v-btn
      >
    </template>
    <v-card>
      <v-card-title>
        <span class="headline mx-auto">Créer un compte</span>
      </v-card-title>
      <v-divider></v-divider>
      <v-container>
        <v-row justify="center">
          <v-col cols="10">
            <v-form lazy-validation>
              <v-text-field
                v-model="email"
                :rules="emailRules"
                label="Email"
                append-icon="mdi-email"
                outlined
                type="email"
                autofocus
                required
                dense
              ></v-text-field>
              <v-text-field
                v-model="nickname"
                :rules="nicknameRules"
                label="Pseudonyme"
                append-icon="mdi-account"
                outlined
                type="text"
                required
                dense
              ></v-text-field>
              <v-text-field
                v-model="password"
                label="Password"
                append-icon="mdi-lock-question"
                type="Password"
                :rules="passwordRules"
                outlined
                required
                full-width
                dense
              ></v-text-field>
              <v-spacer></v-spacer>
              <v-divider class="mb-6"></v-divider>
              <v-btn
                color="#2837bf"
                :loading="loading"
                block
                dark
                @click="signIn"
                >S'enregistrer</v-btn
              >
            </v-form>
          </v-col>
        </v-row>
        <v-snackbar v-model="successMessage" outlined color="success">
          <v-icon color="success">mdi-check-circle</v-icon>
          <span class="mx-2">Compte créé avec succès !</span>
        </v-snackbar>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import { auth, db } from "@/services/firebaseServices.js";

export default {
  data() {
    return {
      loading: false,
      successMessage: false,
      dialog: false,
      nickname: "",
      nicknameRules: [
        v => !!v || "Pseudo requis !",
        v =>
          v.length >= 3 ||
          "Le pseudonyme doit comporter au moins 3 caractères !"
      ],
      email: "",
      emailRules: [
        v => !!v || "E-mail requis !",
        v => /.+@.+\..+/.test(v) || "L'adresse e-mail doit être valide!"
      ],
      password: "",
      passwordRules: [
        v => !!v || "Mot de passe requis !",
        v => v.length >= 6 || "Minimum 6 caractères"
      ]
    };
  },
  methods: {
    async signIn() {
      try {
        this.loading = true;

        const response = await auth.createUserWithEmailAndPassword(
          this.email,
          this.password
        );

        this.successMessage = true;

        // User creation in Firestore
        const userEmail = response.user.email;
        const userId = response.user.uid;

        const userData = {
          userId: userId,
          userData: {
            email: userEmail,
            nickname: this.nickname,
            firstName: "",
            name: "",
            photo: ""
          }
        };

        await db
          .collection("users")
          .doc(userId)
          .set(userData);

        const userSessions = { sessions: [] };

        await db
          .collection("sessions")
          .doc(userId)
          .set(userSessions);

        this.loading = false;
        setTimeout(() => {
          this.dialog = false;
        }, 2500);
      } catch (error) {
        return error;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
